<div class="upsell-footer">
    <div class="upsell-footer__container px-4 py-8 text-sm mx-auto text-center">
        <div class="upsell-footer__wrapper text-center">
            <div class="footer_line"></div>
            <div class="upsell-footer__links my-4 flex justify-center gap-3">
                <a href="{{ link.page || link.link }}" target="{{ link.target || '_blank' }}" *ngFor="let link of links" title="{{ link.label }}" (click)="navigateToPageByGenericUrl(link.page || link.link, link.target || '_blank', link.options)">{{ link.label }}</a>
            </div>
            <div>
                <div>
                    <p class="mb-4">{{ text }}</p>
                    <p>© {{ year }} {{ brand }}. All Rights Reserved</p>
                    <p>{{ address }}</p>
                </div>
            </div>
        </div>
    </div>
</div>